/* @flow */

export function shouldShowDelimiter(index: number, valuesLength: number) {
    return index !== valuesLength - 1;
}
